import { demoFile, feature } from 'system/demo';

demoFile('feature/question/question-config');

const comment = [
    { key: 1, from: 'a', text: 'I love this movie!' },
    { key: 2, from: 'b', text: 'I hate it' },
    { key: 3, from: 'c', replyTo: 1, text: 'I can reply' },
    { key: 4, from: 'd', replyTo: 3, text: 'I can reply to the reply' },
];

feature('Question Config', {
    structureKey: 'question',
    features: { config_comment: true },
    state: { collections: { comment } },
});
